<template>
  <div class="safety" id="container">
    <div class="safety-container">
      <div class="safety_item item-1" style="grid-column: 1/2;grid-row: 1/2">
        <inspection :project_id="this.project_id"></inspection>
      </div>
      <div class="safety_item item-2" style="grid-column: 1/2;grid-row: 2/3">
        <defect :project_id="project_id"></defect>
      </div>
      <div class="safety_item item-3" style="grid-column: 1/2;grid-row: 3/4">
        <equipment :project_id="project_id"></equipment>
      </div>
      <div class="safety_item item-4" style="grid-column: 2/4;grid-row: 1/3">
        <spot></spot>
      </div>
      <div class="safety_item item-5" style="grid-column: 2/3;grid-row: 3/4">
        <subcontract :project_id="project_id"></subcontract>
      </div>
      <div class="safety_item item-6" style="grid-column: 3/4;grid-row: 3/4">
        <check :project_id="project_id"></check>
      </div>
      <div class="safety_item item-7"
           style="grid-column: 4/5;grid-row: 1/3; display: grid; grid-template-columns: repeat(2, 50%); grid-template-rows: repeat(2, 50%)">
        <div style="grid-column: 1/3;grid-row: 1/2">
          <gentry :project_id="project_id"></gentry>
        </div>
        <div style="grid-column: 1/3;grid-row: 2/3">
          <ptwclassify :project_id="project_id"></ptwclassify>
        </div>
      </div>
      <div class="safety_item item-8" style="grid-column: 4/5;grid-row: 3/4">
        <defect_status :project_id="project_id"></defect_status>
      </div>
    </div>
  </div>
</template>

<script>
import inspection from '@/components/quality/inspection'
import defect from '@/components/quality/defect'
import defect_status from '@/components/quality/defect_status'
import gentry from '@/components/quality/gentry'
import ptwclassify from '@/components/quality/ptwclassify'
import spot from '@/components/spot/spot2'
import check from '@/components/quality/check_status'
import subcontract from '@/components/quality/subcontract'
import equipment from '@/components/quality/equipment'
// import ptw from '@/components/quality/proj_ptw'

export default {
  name: "quality",
  props: ['project_id'],

  data() {
    return {
      tbmCount: [],
      tbmEmpty: true,
      nowTime: '',
      startDate: '2018-08-15',
      startTimes: '',
      container: '',
    }
  },
  methods: {},
  components: {
    inspection,
    defect,
    check,
    gentry,
    equipment,
    subcontract,
    defect_status,
    // ptw,
    ptwclassify,
    spot
  },
  mounted() {
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
/**
  box-sizing: border-box;
  overflow: hidden*/

.quality {
  width: 100%
  height: 100%
  position: relative;
}

.safety-container {
  position: relative;
  width: 100%
  height: 100%
  display: grid
  text-align: center;
  grid-template-columns repeat(4, 24.5%)
  grid-template-rows repeat(3, 32.5%)
  place-content space-between space-between
  overflow: hidden
}

.safety_item {
  position: relative
  font-size 1em
  text-align: center;
  line-height: auto
  background-color #31334a
}
</style>



// WEBPACK FOOTER //
// src/components/quality/quality.vue